import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './NavBar.css';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import { Container, Row } from 'react-bootstrap';


const NavBar = ({ darkMode }) => {



  const downloadCV = () => {
    const lang = language === 'es' ? 'es' : 'en';
    const fileName = `cv-${lang}.pdf`;
    const filePath = require(`../../Assets/${fileName}`);
    fetch(filePath)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error('Error downloading CV:', error);
      });
  };
  




  const [isOpen, setIsOpen] = useState(false);
  const [clicked, setClicked] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const handleClick = () => {
    setClicked(!clicked);
    setIsOpen(false); 
  };

  const { t, i18n } = useTranslation();
const [language, setLanguage] = useState('en');
  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    setLanguage(language);
  };

  return (
    <Container>
      <Row>
        <nav className={`navbar na ${isOpen ? 'open' : ''}`}>
          <div className="navbar__logo">
            <NavLink to="/">
            <svg width="66" height="70" viewBox="0 0 66 70" xmlns="http://www.w3.org/2000/svg">
              <path d="M29.41 42.3099C29.08 36.1099 19.72 36.4999 19.72 42.7099V43.0899C19.7196 43.7926 19.5609 44.4862 19.2557 45.1192C18.9506 45.7522 18.5068 46.3083 17.9574 46.7464C17.4079 47.1844 16.7668 47.4931 16.0817 47.6495C15.3967 47.8059 14.6852 47.8061 14 47.6499C13.1533 47.4128 12.3818 46.9617 11.76 46.3399C11.1383 45.7181 10.6871 44.9467 10.45 44.0999L10.34 43.5499V9.54989C10.34 8.44659 9.90174 7.38848 9.12159 6.60833C8.34144 5.82818 7.28333 5.38989 6.18003 5.38989H4.81003C3.70673 5.38989 2.64861 5.82818 1.86846 6.60833C1.08831 7.38848 0.650028 8.44659 0.650028 9.54989V42.3799C0.650028 42.4399 0.650028 42.4899 0.650028 42.5499C0.650028 42.6099 0.650028 42.9099 0.650028 43.0899C0.634115 46.9064 2.13494 50.5728 4.82233 53.2827C7.50973 55.9926 11.1636 57.524 14.98 57.5399C18.7965 57.5558 22.463 56.055 25.1729 53.3676C27.8828 50.6802 29.4141 47.0264 29.43 43.2099C29.44 42.9099 29.43 42.6099 29.41 42.3099Z" />
              <path d="M30.6099 47.58C30.2015 48.3193 29.9937 49.1527 30.0072 49.9972C30.0206 50.8418 30.2549 51.6681 30.6866 52.3941C31.1184 53.12 31.7326 53.7204 32.4682 54.1354C33.2038 54.5505 34.0353 54.7658 34.8799 54.76C35.7413 54.7454 36.5843 54.5085 37.3271 54.0722C38.07 53.6359 38.6875 53.0151 39.1199 52.27C39.5464 51.5967 40.1376 51.0431 40.8374 50.6617C41.5373 50.2803 42.3229 50.0835 43.1199 50.09C44.3546 50.1055 45.5345 50.6022 46.4085 51.4743C47.2826 52.3465 47.7818 53.5253 47.7999 54.76C47.7973 56.0004 47.3033 57.1892 46.4262 58.0663C45.5491 58.9434 44.3603 59.4373 43.1199 59.44H6.19989C5.56871 59.4387 4.94346 59.5619 4.35994 59.8025C3.77642 60.0431 3.2461 60.3965 2.79931 60.8423C2.35253 61.2882 1.99807 61.8178 1.75623 62.4008C1.51438 62.9838 1.38989 63.6088 1.38989 64.24V64.35C1.38989 65.6257 1.89666 66.8491 2.79871 67.7512C3.70076 68.6532 4.9242 69.16 6.19989 69.16H43.4699C45.978 69.0906 48.4244 68.3665 50.5663 67.0598C52.7082 65.753 54.4712 63.9089 55.6804 61.7104C56.8896 59.512 57.5029 57.0355 57.4596 54.5268C57.4162 52.0181 56.7176 49.5644 55.4332 47.409C54.1488 45.2536 52.3231 43.4715 50.1373 42.2396C47.9515 41.0076 45.4816 40.3686 42.9726 40.3858C40.4636 40.4031 38.0027 41.0761 35.8341 42.3381C33.6655 43.6001 31.8645 45.4071 30.6099 47.58Z" />
              <path d="M58.4501 44.5899C59.1961 45.033 60.0447 45.2743 60.9123 45.2901C61.7799 45.3059 62.6366 45.0956 63.3983 44.68C64.16 44.2643 64.8005 43.6576 65.2566 42.9194C65.7128 42.1813 65.969 41.3371 66.0001 40.4699C65.9618 37.9665 65.2809 35.515 64.0226 33.3504C62.7643 31.1859 60.9709 29.3811 58.8144 28.109C56.6579 26.837 54.2107 26.1406 51.7076 26.0864C49.2045 26.0323 46.7295 26.6223 44.5201 27.7999C41.3701 29.4899 40.6801 33.1299 43.2301 35.6399C44.0035 36.386 45 36.8584 46.0672 36.9848C47.1344 37.1112 48.2137 36.8847 49.1401 36.3399C49.838 35.9686 50.6188 35.7805 51.4092 35.7933C52.1997 35.8061 52.974 36.0193 53.6595 36.4131C54.345 36.8068 54.9194 37.3681 55.3288 38.0445C55.7381 38.7208 55.9691 39.49 56.0001 40.2799C56.0184 41.1464 56.2531 41.9946 56.6827 42.7473C57.1124 43.5 57.7233 44.1334 58.4601 44.5899H58.4501Z" />
              <path d="M32.2199 21.33C32.2203 22.0302 32.0633 22.7214 31.7605 23.3527C31.4576 23.984 31.0167 24.5391 30.4704 24.9769C29.924 25.4148 29.2862 25.7242 28.6041 25.8822C27.922 26.0403 27.2132 26.0429 26.5299 25.89C25.688 25.6509 24.9215 25.1999 24.3035 24.5801C23.6855 23.9604 23.2367 23.1926 22.9999 22.35C22.7855 21.3838 22.883 20.3744 23.2783 19.4671C23.6735 18.5597 24.3463 17.801 25.1999 17.3C25.9072 16.8953 26.4975 16.3139 26.9129 15.6128C27.3283 14.9117 27.5547 14.1148 27.5699 13.3V13.17C27.5772 12.3234 27.3628 11.4896 26.9479 10.7516C26.5331 10.0135 25.9322 9.39693 25.2052 8.96311C24.4781 8.5293 23.6501 8.29337 22.8036 8.2788C21.9571 8.26422 21.1215 8.47149 20.3799 8.88001C18.1924 10.1384 16.374 11.9497 15.1069 14.1322C13.8398 16.3148 13.1686 18.792 13.1605 21.3156C13.1523 23.8393 13.8076 26.3208 15.0606 28.5115C16.3136 30.7021 18.1203 32.525 20.2996 33.7975C22.479 35.07 24.9546 35.7474 27.4782 35.7618C30.0019 35.7762 32.485 35.1271 34.6787 33.8796C36.8725 32.6321 38.6999 30.8299 39.9778 28.6537C41.2557 26.4775 41.9392 24.0036 41.9599 21.48C41.9599 21.18 41.9599 20.88 41.9599 20.58C41.6299 14.38 32.2599 14.78 32.2599 20.99L32.2199 21.33Z" />
              <path d="M30.4701 6.77994C32.0827 6.77994 33.39 5.47261 33.39 3.85994C33.39 2.24727 32.0827 0.939941 30.4701 0.939941C28.8574 0.939941 27.55 2.24727 27.55 3.85994C27.55 5.47261 28.8574 6.77994 30.4701 6.77994Z" />
              <path d="M41.94 12.84C43.5527 12.84 44.86 11.5327 44.86 9.92C44.86 8.30733 43.5527 7 41.94 7C40.3273 7 39.02 8.30733 39.02 9.92C39.02 11.5327 40.3273 12.84 41.94 12.84Z" />
              </svg>
            </NavLink>
          </div>
          <button className={`navbar__toggle-btn`} onClick={toggleNavbar}>
            <span className="navbar__toggle-icon" />
          </button>

        <ul className={`navbar__menu ${isOpen ? 'open' : ''}`}>
            <motion.div
              animate={{ y: 20 }}
              transition={{ duration: 1 }}
              className={`lista ${clicked ? 'active' : ''}`}
            >
            <li className="languaje">
                <Link className="idioma" onClick={() => changeLanguage('en')}>EN</Link>
                <Link className="idioma" onClick={() => changeLanguage('es')}>ES</Link>
            </li>
            </motion.div>
        </ul>
        </nav>
      </Row>
    </Container>
  );
};

export default NavBar;
